module.exports = __webpack_public_path__ + "static/media/Iquique.16236823.png";